import * as TK from 'components/PDP/Order/ValidationAlert/translations/translation-keys.constants';

export const validationAlertCommonLocale = {
  [TK.RECIPIENT_VALIDATION_ALERT]:
    'Please complete all required fields following its requirements',
};
